import React from "react";
import PropTypes from "prop-types";
import Select, { components } from "react-select";
import "./SelectStyles.scss";
// //
// import { RiArrowUpSFill, RiArrowDownSFill } from "react-icons/ri";

// const DropdownIndicator = (props) => {
//   return (
//     <components.DropdownIndicator {...props}>
//       <div style={{ display: "flex", flexDirection: "column" }}>
//         <RiArrowUpSFill />
//         <RiArrowDownSFill />
//       </div>
//     </components.DropdownIndicator>
//   );
// };

const SelectView = ({
  className = "",
  isrequired = false,
  error,
  label,
  options,
  isSearchable,
  isClearable,
  isRowCap = false,
  ...props
}) => {
  return (
    <div className={`select_wrapper ${isRowCap && "row-cap-wrapper"}`}>
      {label && (
        <span className={`select__label text-muted`}>
          {label} {isrequired && <span /*className="text-danger"*/>*</span>}
        </span>
      )}
      <Select
        options={options}
        isClearable={!!isClearable}
        isSearchable={!!isSearchable}
        className={`select ${className} ${error ? "error" : ""} `}
        classNamePrefix={`select`}
        placeholder={""}
        // components={{ DropdownIndicator }}

        {...props}
      />
      <div className={error ? `errorText` : "d-none"}>{error ? error : ""}</div>
    </div>
  );
};

SelectView.propTypes = {
  className: PropTypes.string,
  error: PropTypes.string,
  label: PropTypes.string,
  isSearchable: PropTypes.bool,
  isClearable: PropTypes.bool,
  options: PropTypes.array,
};

export default SelectView;
